export default __webpack_public_path__ + "static/media/D_009.304e0143.jpg";